import _ from 'underscore';

import config from 'src/config';

function WidgetBuilderCtrl($scope, WIDGET_DATA_TYPES, utilsService) {
  if (!$scope.builderConfig) throw new Error('builderConfig is required');
  if (!$scope.widgetPath) throw new Error('widgetPath is required');

  if ($scope.builderConfig.toolbar && $scope.builderConfig.toolbar.length) {
    $scope.builderConfig.toolbar.forEach(field => {
      field.visible = field.visible === false ? false : true; //eslint-disable-line
      field.enabled = field.type !== WIDGET_DATA_TYPES.DATE;
    });
  }

  $scope.WIDGET_DATA_TYPES = WIDGET_DATA_TYPES;
  $scope.iframeSrc = null;
  $scope.iframeId = utilsService.generateGuid();
  $scope.coreJsSnippet = function () {
    return `<script src="${config.WIDGET_BASE_URL}/widgets/embedded/tablelist-widgets-core.min.js"></script>`;
    // return '<script src="https://widgets-dev.tablelist.com/widgets/embedded/tablelist-widgets-core.min.js"></script>';
  };
  $scope.widgetJsSnippet = function () {
    const attributes = _buildAttributionFromToolbarConfig($scope.builderConfig.toolbar);

    return `<div data-tl-widget="${this.widgetName}" ${attributes}></div>`;
  };
  $scope.updateIframeSrcWithToolbarOptionsThrottled = _.debounce(_updateIframeSrcWithToolbarOptions, 60);

  $scope.$watch('venue', val => {
    if (val) {
      _updateIframeSrcWithToolbarOptions();
    }
  });

  $scope.$watch('builderConfig', val => {
    if (val && val.toolbar && val.toolbar.length) {
      $scope.updateIframeSrcWithToolbarOptionsThrottled();
    }
  }, true);

  $scope.refreshIframe = function () {
    $scope.iframeSrc = $scope.iframeSrc + ($scope.iframeSrc.indexOf('?') > 0 ? '&' : '?') + 'refresh=' + (new Date()).getTime(); //eslint-disable-line
  };

  $scope.selectPreset = function (preset, $event) {
    if (!preset || !preset.fields) return;
    if ($event) $event.preventDefault();

    preset.fields.forEach(field => {
      const foundField = _.findWhere($scope.builderConfig.toolbar, {
        key: field.key
      });

      if (foundField) {
        foundField.value = field.value;
      }
    });

    _updateIframeSrcWithToolbarOptions();
  };

  $scope.fieldChanged = function () {
    $scope.refreshIframe();
  };

  function _updateIframeSrcWithToolbarOptions() {
    let src = `${config.WIDGET_BASE_URL}${$scope.widgetPath}?`;
    // let src = `https://widgets-dev.tablelist.com${$scope.widgetPath}?`;

    $scope.builderConfig.toolbar.forEach(field => {
      if (field.value && field.enabled) {
        let fieldValue = _.isFunction(field.value) ? field.value() : field.value;

        if (field.type === WIDGET_DATA_TYPES.COLOR) {
          fieldValue = field.value.replace('#', '');
        } else if (field.type === WIDGET_DATA_TYPES.DATE) {
          if (field.value.isValid && _.isFunction(field.value.isValid)) fieldValue = field.value.toDate().getTime();
          else fieldValue = field.value.getTime();
        }

        src += `&${field.key}=${fieldValue}`;
      }
    });

    $scope.iframeSrc = src;
    $scope.iframeSrc += $scope.iframeSrc.indexOf('?') > 0 ? `&iframeId=${$scope.iframeId}` : `?iframeId=${$scope.iframeId}`;
  }

  function _buildAttributionFromToolbarConfig(toolbar) {
    if (!toolbar) throw new Error('toolbar');

    let attributes = '';

    toolbar.forEach((field, index) => {
      let kebabField = _camelToKebab(field.key);
      kebabField = kebabField ? kebabField.toLowerCase() : kebabField;

      let fieldValue = _.isFunction(field.value) ? field.value() : field.value;

      if (index !== 0) {
        attributes += ' ';
      }

      if (field.type === WIDGET_DATA_TYPES.COLOR) {
        fieldValue = field.value.replace('#', '');
      } else if (field.type === WIDGET_DATA_TYPES.DATE) {
        fieldValue = field.value.toISOString();
      }

      attributes += `data-${kebabField}="${fieldValue}"`;
    });

    return attributes;
  }

  function _camelToKebab(str) {
    return str.replace(/\W+/g, '-')
      .replace(/([a-z\d])([A-Z])/g, '$1-$2');
  }
}

WidgetBuilderCtrl.$inject = [
  '$scope',
  'WIDGET_DATA_TYPES',
  'utilsService'
];

export default WidgetBuilderCtrl;



// WEBPACK FOOTER //
// ./src/directives/widgets/widgetBuilder/controller.js